<template>
  <div class="absolute inset-0 flex items-start justify-end m-[-5px] gap-[3px]">
    <slot></slot>
  </div>
</template>
